import { render } from "./EditQuotation.vue?vue&type=template&id=55ae52f7&scoped=true"
import script from "./EditQuotation.vue?vue&type=script&lang=js"
export * from "./EditQuotation.vue?vue&type=script&lang=js"

import "./EditQuotation.vue?vue&type=style&index=0&id=55ae52f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ae52f7"]])

export default __exports__